// frontend/src/components/common/ConfirmDialog.js
//
// Återanvändbar bekräftelse-dialog i appens modal-stil (styles/modals.css).
// Ersätter webbläsarens window.confirm med en snygg, appkonsekvent ruta.
//
// Användning:
//   <ConfirmDialog
//     isOpen={...}
//     variant="danger"
//     title="Ta bort journal?"
//     message="Utkastet tas bort permanent."
//     confirmLabel="Ta bort"
//     loading={...}
//     onConfirm={...}
//     onCancel={...}
//   />

import React, { useEffect } from 'react';

const VARIANT_ICON = {
  danger: 'fa-exclamation-triangle',
  warning: 'fa-exclamation-triangle',
  info: 'fa-info-circle',
  success: 'fa-check-circle',
};

const VARIANT_CONFIRM_BTN = {
  danger: 'btn btn-danger',
  warning: 'btn btn-danger',
  info: 'btn btn-primary',
  success: 'btn btn-success',
};

function ConfirmDialog({
  isOpen,
  title = 'Är du säker?',
  message,
  confirmLabel = 'Bekräfta',
  cancelLabel = 'Avbryt',
  variant = 'danger',
  loading = false,
  onConfirm,
  onCancel,
}) {
  // Escape stänger dialogen (om den inte håller på att köra)
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && !loading && onCancel) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, loading, onCancel]);

  if (!isOpen) return null;

  const icon = VARIANT_ICON[variant] || VARIANT_ICON.danger;
  const confirmBtnClass = VARIANT_CONFIRM_BTN[variant] || VARIANT_CONFIRM_BTN.danger;

  return (
    <div
      className="modal-overlay"
      onClick={() => { if (!loading && onCancel) onCancel(); }}
    >
      <div
        className="modal-container modal-confirm modal-xs"
        role="alertdialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-body">
          <div className={`modal-confirm-icon ${variant}`}>
            <i className={`fas ${icon}`}></i>
          </div>
          <div className="modal-confirm-title">{title}</div>
          {message && <div className="modal-confirm-text">{message}</div>}
        </div>
        <div className="modal-footer footer-center">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={confirmBtnClass}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <><i className="fas fa-spinner fa-spin"></i> {confirmLabel}</>
            ) : (
              confirmLabel
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
